"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shopCarOrderApi = _interopRequireWildcard(require("@/api/shopCarOrderApi"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ShopCarOrderDetail',
  data: function data() {
    return {
      visible: false,
      loading: false,
      detail: {},
      beansDialogVisible: false
    };
  },
  methods: {
    open: function open(orderNo) {
      var _this = this;
      if (!orderNo) {
        this.$message.warning('订单编号缺失');
        return;
      }
      this.visible = true;
      this.loading = true;
      this.detail = {};
      this.beansDialogVisible = false;
      shopCarOrderApi.getShopCarOrderDetail(orderNo).then(function (res) {
        _this.detail = res;
      }).catch(function (err) {
        console.error('获取订单详情失败:', err);
        _this.$message.error(err && err.message || '获取订单详情失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleClose: function handleClose() {
      this.visible = false;
      this.detail = {};
      this.beansDialogVisible = false;
    },
    handleViewBeans: function handleViewBeans() {
      this.beansDialogVisible = true;
    },
    getOrderStatusType: function getOrderStatusType(statusName) {
      if (!statusName) return '';
      var status = statusName.toLowerCase();
      if (status.includes('成功') || status.includes('完成') || status.includes('已支付')) {
        return 'success';
      }
      if (status.includes('待') || status.includes('处理中')) {
        return 'warning';
      }
      if (status.includes('失败') || status.includes('取消') || status.includes('关闭')) {
        return 'info';
      }
      if (status.includes('退款')) {
        return 'danger';
      }
      return '';
    }
  }
};